import httpRequest from "@/services/httpRequest"

export default ({
  namespaced: true,
  state: {
    isLoading: false,
    isInfiniteLoading: false,
    page: 1,
    pageSize: 10,
    hasMore: true,
    listStudentBills: [],
    studentBillsItem: null,
    paymentBill: null,
    listPaymentHistory: [],
    paymentHistoryItem: {},
  },
  mutations: {
    SET_LOADING(state, status) { state.isLoading = status },
    SET_INFINITE_LOADING(state, status) { state.isInfiniteLoading = status },
    SET_HAS_MORE(state, status) { state.hasMore = status },
    SET_PAGE(state, page) { state.page = page },
    // Mutation untuk data list listStudentBills
    SET_LIST_STUDENT_BILLS(state, data) {
      state.listStudentBills = data
    },
    APPEND_LIST_STUDENT_BILLS(state, data) {
      state.listStudentBills = [...state.listStudentBills, ...data]
    },
    SET_STUDENT_BILLS_ITEM(state, data) {
      state.studentBillsItem = data
    },
    SET_PAYMENT_BILL(state, data) {
      state.paymentBill = data
    },
    SET_LIST_PAYMENT_HISTORY(state, data) {
      state.listPaymentHistory = data
    },
    APPEND_LIST_PAYMENT_HISTORY(state, data) {
      state.listPaymentHistory = [...state.listPaymentHistory, ...data]
    },
    SET_PAYMENT_HISTORY_ITEM(state, data) {
      state.paymentHistoryItem = data
    }
  },
  actions: {
    async getListStudentBills({ rootState, state, commit }, { param, first = true }) {
      // Reset atau Increment Page via Mutation
      if (first) {
        commit('SET_PAGE', 1)
        commit('SET_HAS_MORE', true)
        commit('SET_LOADING', true)
      } else {
        if (!state.hasMore) return; // Stop jika sudah tidak ada data
        commit('SET_PAGE', state.page + 1)
        commit('SET_INFINITE_LOADING', true)
      }

      try {
        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/studentbill`,
            method: 'GET',
            params: {
              ...param,
              page: state.page,
              rows: state.pageSize,
              // have_bill:false,
              // classroom:41
            }
          },
          authorized: true
        }

        const res = await httpRequest(payload)
        if (res.status === 200) {
          const results = res.data.results || []

          // Cek apakah masih ada data untuk load berikutnya
          if (results.length < state.pageSize) {
            commit('SET_HAS_MORE', false)
            //console.log('stop load data')
          }

          // Simpan data (Replace jika pertama, Append jika scroll)
          if (first) {
            commit('SET_LIST_STUDENT_BILLS', results)
            //console.log('first load data')
          } else {
            commit('APPEND_LIST_STUDENT_BILLS', results)
            //console.log('load more data')
          }

          return { status: 'success' };
        }
      } catch (error) {
        //console.log('Error fetching student bills:', error)
        return { status: 'error' };
      } finally {
        // Pastikan loading state mati baik sukses maupun gagal
        commit('SET_LOADING', false)
        commit('SET_INFINITE_LOADING', false)
      }
    },
    async createPaymentBill({ rootState, state, commit }, { data }) {
      try {
        commit('SET_LOADING', true)

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/paymentcode/liability`,
            method: 'POST',
            data: data
          },
          authorized: true
        }

        const res = await httpRequest(payload)
        if ([200, 201].includes(res.status)) {
          commit('SET_PAYMENT_BILL', res.data)
        }

      } catch (error) {
         //console.log('Error create payment bills:', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async submitPayBills({ rootState, state, commit }, { id, data }) {
      try {
        // commit('SET_LOADING', true)

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/studentbill/${id}/manual_pay`,
            method: 'POST',
            data: data
          },
          authorized: true
        }

        const res = await httpRequest(payload)
        if ([200, 201].includes(res.status)) {
          //console.log('sukses bayar', res.data)
        }

      } catch (error) {
         //console.log('Error pay bills:', error)
      } finally {
        // commit('SET_LOADING', false)
      }
    },
    async addBillToPayment({ rootState, state, commit }, { id, data }) {
      try {
        // commit('SET_LOADING', true)

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/studentedupayment`,
            method: 'POST',
            data: data
          },
          authorized: true
        }

        const res = await httpRequest(payload)
        if ([200, 201].includes(res.status)) {
          //console.log('sukses tambah bill spp', res.data)
        }

      } catch (error) {
         //console.log('Error pay bills:', error)
      } finally {
        // commit('SET_LOADING', false)
      }
    },
    async getPaymentHistory({ rootState, state, commit }, { studentId, first = true }) {
      // Reset atau Increment Page via Mutation
      if (first) {
        commit('SET_PAGE', 1)
        commit('SET_HAS_MORE', true)
        commit('SET_LOADING', true)
      } else {
        if (!state.hasMore) return; // Stop jika sudah tidak ada data
        commit('SET_PAGE', state.page + 1)
        commit('SET_INFINITE_LOADING', true)
      }

      try {
        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/studentbill/${studentId}/history`,
            method: 'GET',
            params: {
              page: state.page,
              rows: state.pageSize,
            }
          },
          authorized: true
        }

        const res = await httpRequest(payload)
        if (res.status === 200) {
          const results = res.data.results || []

          // Cek apakah masih ada data untuk load berikutnya
          if (results.length < state.pageSize) {
            commit('SET_HAS_MORE', false)
            //console.log('stop load data')
          }

          // Simpan data (Replace jika pertama, Append jika scroll)
          if (first) {
            commit('SET_LIST_PAYMENT_HISTORY', results)
            //console.log('first load data payment history')
          } else {
            commit('APPEND_LIST_PAYMENT_HISTORY', results)
            //console.log('load more data payment history')
          }

          return { status: 'success' };
        }
      } catch (error) {
        //console.log('Error fetching student bills:', error)
        return { status: 'error' };
      } finally {
        // Pastikan loading state mati baik sukses maupun gagal
        commit('SET_LOADING', false)
        commit('SET_INFINITE_LOADING', false)
      }
    },
  }
})